import { defineStore } from 'pinia';

import { ref } from 'vue';

/**
 * ref is like a state
 * computed is like getters
 * methods are like actions
 */
export const usePlannerStore = defineStore('planner', () => {
  // state
  const plannerInfo = ref({ })

  const amplifySubscription = ref(null);

  const siteInfo = ref({});

  // actions
  const setSiteInfo = (info) => {
    siteInfo.value = info;
  }

  const setAmplifySubscription = (subscription) => {
    amplifySubscription.value = subscription;
  }

  const setPlannerInfo = (info) => {
    plannerInfo.value = info;
  }

  const setPlannerInfoByPageId = (pageId, info) => {
    plannerInfo.value[pageId] = info;
  }

  const fetchSessions = async (args) => {
    const { workspace, area, period, reservationPeriod, plannerMonthsToIndex, timeframe, timezone, codeSiteComptage, isInternalSession, time, pageId } = args;

    const baseUrl = `/sport-station/api/areas-offers/migrated?workspace=${workspace}&espace=${area}&period=${period}&reservationPeriod=${reservationPeriod}&plannerMonthsToIndex=${plannerMonthsToIndex}&timeframe=${timeframe}&timezone=${timezone}&codeSiteComptage=${codeSiteComptage}&isInternalSession=${isInternalSession}&time=${time}`;

  const response = await fetch(`${baseUrl}`)
    .then(async response => response.json())
    .catch(error => {
      console.log('Error fetching web componenet areas offers sessions', error);
      return {};
    })
    setPlannerInfoByPageId(pageId, {...response, timeframe, timezone, isCustomPlanner: false });
  }

  const fetchCustomPlanner = async (pageId, pageUuid) => {
    const baseUrl = `/sport-station/api/custom-planner/${pageUuid}/${pageId}`;

    const response = await fetch(`${baseUrl}`)
      .then(async response => response.json())
      .catch(error => {
        console.log('Error fetching web componenet custom planner sessions', error);
        return {};
      })
    
    setPlannerInfoByPageId(pageId, {...response, isCustomPlanner: true });
  }

  return {
    plannerInfo,
    setPlannerInfoByPageId,
    setPlannerInfo,
    fetchSessions,
    fetchCustomPlanner,
    amplifySubscription,
    setAmplifySubscription,
    siteInfo,
    setSiteInfo
  }
})